<template>
  <v-app>
    <AppBar v-if="isAuthenticated"/>

    <v-main>
      <router-view/>
    </v-main>

    <Notification></Notification>
  </v-app>
</template>

<script>
import AppBar from '@/components/AppBar'
import Notification from '@/components/shared/NotificationComp'
import { getCableConsumer } from '@/plugins/cable'

export default {
  name: 'App',

  data: () => ({
    notificationSubscription: null,
  }),

  components:{
    AppBar,
    Notification
  },

  methods: {
    _subscribeToNotifications () {
      if (this.notificationSubscription) return

      const consumer = getCableConsumer()
      if (!consumer) return

      this.notificationSubscription = consumer.subscriptions.create(
        'NotificationsChannel',
        {
          received: (data) => {
            if (data.type === 'new_notification') {
              const isTicketNotification = data.notification?.resource_type === 'SupportTicket'
              const isViewingTicket =
                isTicketNotification &&
                this.$route?.name === 'showSupportTicket' &&
                this.$route?.params?.id === data.notification?.resource_id

              if (!isViewingTicket) {
                this.$store.dispatch('setNotification', {
                  type: 'info',
                  message: data.notification?.title || data.notification?.body || ''
                })
              }
              if (isTicketNotification && !isViewingTicket) {
                this.$store.dispatch('fetchUnreadCount')
              }
              return
            }

            if ([
              'ticket_created',
              'ticket_new_user_message',
              'ticket_updated',
              'ticket_support_read',
              'ticket_support_requested',
              'ticket_support_joined'
            ].includes(data.type)) {
              this.$store.dispatch('fetchUnreadCount')
            }
          }
        }
      )
    },

    _unsubscribeFromNotifications () {
      this.notificationSubscription?.unsubscribe()
      this.notificationSubscription = null
    },
  },

  watch: {
    isAuthenticated (value) {
      if (value) {
        this.$store.dispatch('fetchUnreadCount')
        this._subscribeToNotifications()
      } else {
        this._unsubscribeFromNotifications()
      }
    },
  },

  mounted () {
    if (this.isAuthenticated) {
      this.$store.dispatch('fetchUnreadCount')
      this._subscribeToNotifications()
    }
  },

  beforeUnmount () {
    this._unsubscribeFromNotifications()
  },
}
</script>
